export default {
  success: '成功',
  warning: '警告',
  info: '提示',
  error: '失败'
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/message.js